import React, { useEffect, useRef } from 'react';
import logger from '../lib/logger';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../lib/api';
import LoadingSpinner from '../components/LoadingSpinner';

const AuthCallback = () => {
  const navigate = useNavigate();
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;

    const handleCallback = async () => {
      try {
        // Backend Google OAuth callback redirects here with app token in hash.
        // Support query fallback and ID token exchange for alternate flows.
        const hash = window.location.hash;
        const hashParams = new URLSearchParams(hash.substring(1));
        const queryParams = new URLSearchParams(window.location.search);
        const appTokenFromUrl = hashParams.get('access_token') || queryParams.get('access_token');

        const oauthError = hashParams.get('error_description') || queryParams.get('error_description') || hashParams.get('error') || queryParams.get('error');
        if (oauthError) {
          throw new Error(oauthError);
        }

        if (appTokenFromUrl) {
          localStorage.setItem('token', appTokenFromUrl);
          window.location.replace('/dashboard');
          return;
        }

        // Fallback: if a Google ID token is present, exchange it with backend.
        const googleIdToken = hashParams.get('id_token') || queryParams.get('id_token') || queryParams.get('credential');
        if (!googleIdToken) {
          throw new Error('No OAuth token found in callback URL');
        }

        const response = await authAPI.googleAuth({ id_token: googleIdToken });
        const appToken = response.data.access_token;

        if (!appToken) {
          throw new Error('Backend did not return an app token');
        }

        // Store our app JWT and hard redirect to guarantee auth context refresh
        // across all deployment/build combinations.
        localStorage.setItem('token', appToken);
        window.location.replace('/dashboard');
      } catch (err) {
        logger.error('Google OAuth callback error:', err);
        navigate('/auth?mode=login&error=google_failed', { replace: true });
      }
    };

    handleCallback();
  }, [navigate]);

  return (
    <LoadingSpinner size="lg" text="Signing you in with Google..." fullScreen={true} />
  );
};

export default AuthCallback;
